import { addWeeks, endOfWeek, format, startOfWeek } from "date-fns";
import { ChevronLeft, ChevronRight } from "lucide-react";
import Button from "../Button/Button";
import "./WeekNavigator.css";

/**
 * "‹ 02 Feb - 08 Feb'26 ›" week picker.
 * weekStart:    any date inside the week to show
 * onChange:     called with the start date of the previous / next week
 * weekStartsOn: 0 = Sunday, 1 = Monday (default)
 */
const WeekNavigator = ({ weekStart, onChange, weekStartsOn = 1 }) => {
  const start = startOfWeek(weekStart, { weekStartsOn });
  const end = endOfWeek(weekStart, { weekStartsOn });

  return (
    <div className="week-navigator">
      <Button
        variant="link"
        size="sm"
        icon={<ChevronLeft size={14} />}
        onClick={() => onChange(addWeeks(start, -1))}
        aria-label="Previous week"
      />
      <span>{`${format(start, "dd MMM")} - ${format(end, "dd MMM''yy")}`}</span>
      <Button
        variant="link"
        size="sm"
        icon={<ChevronRight size={14} />}
        onClick={() => onChange(addWeeks(start, 1))}
        aria-label="Next week"
      />
    </div>
  );
};

export default WeekNavigator;
